import iconJointUser from '@shared_modules/common-images/loantype-joint.svg';
import iconUser from '@shared_modules/common-images/loantype-individual.svg';

export const INDIVIDUAL = 'individual';
export const JOINT = 'joint';
export const LOAN_TYPES = {
  [INDIVIDUAL]: INDIVIDUAL,
  [JOINT]: JOINT,
};

export const LOAN_TYPE_CONTENTS = {
  [INDIVIDUAL]: {
    image: {
      src: iconUser,
      alt: 'Individual Application',
    },
    text: 'Just Me',
    description: 'We will make the best offer for you in no time.',
  },
  [JOINT]: {
    image: {
      src: iconJointUser,
      alt: 'Joint Application',
    },
    text: 'Two Of Us',
    description:
      "We'll consider your combined credit situation and income to make an offer, which may get you a better rate and approval for a higher loan amount.",
  },
};

